import { render, staticRenderFns } from "./WarehouseSelector.vue?vue&type=template&id=8b79407a&"
import script from "./WarehouseSelector.vue?vue&type=script&lang=js&"
export * from "./WarehouseSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports